'use client'

import { debounce } from "lodash"
import { createContext, useCallback, useContext, useLayoutEffect, useState } from "react"
import { useDevice } from "./DecideProvider"


type ResponsiveSize = 'default' | 'sm' | 'md' | 'lg' | 'xl' | '2xl'


enum ResponSiveSizeEnum {
  default = 0,
  sm = 640,
  md = 768,
  lg = 1024,
  xl = 1280,
  "2xl" = 1536,
}
const keys = ['default', 'sm', 'md', 'lg', 'xl', '2xl']


const ResponsiveSizeContext = createContext<ResponsiveSize>(null!)

export const computedSize = () => {
  const sizeList = keys.map(key => ResponSiveSizeEnum[key]).sort((a, b) => b - a)

  for (const val of sizeList.values()) {
    if (window.innerWidth >= val) {
      return ResponSiveSizeEnum[val] as ResponsiveSize
    }
  }
  return 'default'
}


export const ResponsiveSizeProvider = ({ children }) => {

  const device = useDevice()
  const getSize = useCallback(() => {
    return computedSize()
  }, [])


  const [size, setSize] = useState<ResponsiveSize>(device === 'mobile' ? 'default' : 'lg')


  useLayoutEffect(() => {
    const resizeFn = debounce(() => {
      setSize(getSize())
    }, 200)

    setSize(getSize())

    window.addEventListener('resize', resizeFn)

    return () => {
      window.removeEventListener('resize', resizeFn)
    }

  }, [])

  return (<ResponsiveSizeContext.Provider value={size}>
    {children}
  </ResponsiveSizeContext.Provider>)
}


export const useResponsiveSize = (pickList: ResponsiveSize[] = []): ResponsiveSize => {

  const value = ResponSiveSizeEnum[useContext(ResponsiveSizeContext)]
  const pickListSize = pickList.map(key => ResponSiveSizeEnum[key]).sort((a, b) => b - a)
  if (pickList) {
    for (const pickVal of pickListSize) {
      if (value >= pickVal) {
        return ResponSiveSizeEnum[pickVal] as ResponsiveSize
      }
    }
  }

  return useContext(ResponsiveSizeContext)
}